<template>
  <div class="search-by-image">
    <div class="search-main">
      <div class="search-main-header">
        Search by Image
      </div>
      <div class="search-main-desc">
        Find what you love with better prices on 1688 by using an image search.
      </div>
      <div class="upload-image">
        <div
          v-if="loading"
          class="upload-image-loading-wrapper"
        >
          <div class="upload-image-loading">
            <div class="spinner" />
            <div class="container-text">
              Identifying your image
            </div>
          </div>
        </div>
        <img
          v-if="loading"
          class="upload-image-tempUrl"
          :src="tempImgSrc"
          alt=""
        >
        <div
          class="upload-image-no"
          v-if="!imgSrcBase64"
        >
          <template v-if="!loading">
            <div class="upload-image-drop">
              <img
                src="@/assets/illus/illus-camera.svg"
                alt=""
              >
              Click the button to upload the image
            </div>
            <div class="upload-image-btn">
              <input
                class="upload-auto_input"
                type="file"
                id="upload"
                accept="image/*"
                @input="uploadImg"
              >
              Upload a Photo
            </div>
          </template>
        </div>
        <div
          class="upload-image-open"
          v-if="imgSrcBase64"
        >
          <img
            class="upload-image-tempUrl"
            :src="tempImgSrc"
            alt=""
          >
          <input
            class="reupload-image"
            type="file"
            id="upload"
            accept="image/*"
            @input="uploadImg"
          >
        </div>
      </div>
      <div
        class="upload-image-bottom"
        v-if="!imgSrcBase64"
      >
      </div>
      <div
        class="upload-image-bottom-btn"
        v-if="imgSrcBase64"
      >
        <!-- <div
          class="upload-image-bottom-confirm discovery"
          @click="confirmUpload('discovery')"
        >
          Ai Discovery
          <div class="new-feature-tag">New</div> 
        </div> -->
        <div
          class="upload-image-bottom-confirm"
          @click="confirmUpload('similar')"
        >
          Find to Similar
        </div>
      </div>
    </div>
    <canvas
      id="canvas"
      style="display: none"
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { fetchData } from '@/utils/fetch'
import { useStore } from 'vuex'

import { useRouter } from 'vue-router'
import {
  buriedPointUtil,
  gaAnalytics,
  openURLWithChannelQuery,
  uploadImage
} from '@/utils/utils'

const active = ref(0)
const imgSrcBase64 = ref('')
const drawImage = ref([])
const store = useStore()

const router = useRouter()

const props = defineProps({
  handleClickOutside: Function,
  handleClose: Function
})

const handleClickOutside = props.handleClickOutside
const handleClose = props.handleClose
const loading = ref(false)
const tempImgSrc = ref('')

const uploadImg = async (e) => {
  const file = e.target.files?.[0]
  if (!file) {
    return
  }
  loading.value = true
  imgSrcBase64.value = ''
  tempImgSrc.value = URL.createObjectURL(file)
  active.value = -1
  // upload(files[0]);
  uploadImage(file).then((res) => {
    imgSrcBase64.value = res.fileUrl
    loading.value = false
  }).then(v => {
    // 以下是预加载逻辑
    fetchData('/dsp-app/alibaba-common/imageUpload', {
      method: 'post',
      body: JSON.stringify({
        imageBase64: imgSrcBase64.value
      })
    }).then(data => {
      fetchData('/dsp-app/alibaba-common/searchImage', {
        method: 'post',
        body: JSON.stringify({
          imageId: data.data,
          keyword: '',
          pageNow: 1,
          pageSize: 50,
          region: ''
        })
      })
    })
  })
}

const uploadImgBtn = () => {
  buriedPointUtil({ eventId: 'PSC202' })
}

const cancelUpload = () => {
  buriedPointUtil({ eventId: 'PSC204' })
  imgSrcBase64.value = ''
}

const searchInfo = computed(() => store.getters.searchInfo)

watch(searchInfo, (newData) => {
  if (newData) {
    searchInfo.value = newData
  }
})

const confirmUpload = async (type) => {
  store.commit('setLoading', true)
  if (type === 'similar') {
    buriedPointUtil({ eventId: 'POI201' })
  } else if (type === 'discovery') {
    buriedPointUtil({ eventId: 'POI202' })
  }
  try {
    const { code, data } = await fetchData('/dsp-app/alibaba-common/imageUpload', {
      method: 'post',
      body: JSON.stringify({
        imageBase64: imgSrcBase64.value
      })
    })
    if (code === 200) {
      store.commit('setCurrentMainImage', imgSrcBase64.value)
      sessionStorage.setItem(`currentMainImage_${data}`, imgSrcBase64.value)
      if (type === 'similar') {
        buriedPointUtil({ eventId: 'POI401' })
      } else if (type === 'discovery') {
        buriedPointUtil({ eventId: 'POI402' })
      }
      openURLWithChannelQuery(`/search?imageId=${data}&type=${type}`)
    }
    store.commit('setLoading', false)
    handleClose()
  } catch (error) {
    store.commit('setLoading', false)
  }
}
</script>

<style lang="less" scoped>
.search-by-image {
  .search-main {
    .search-main-header {
      font-family: mon-600;
      font-size: 12px;
      line-height: 16px;
      color: #232323;
    }
    .search-main-desc {
      font-family: mon-400;
      font-size: 10px;
      line-height: 14px;
      color: #6E717A;
      margin-top: 4px;
    }
  }
  .upload-image {
    position: relative;
    border: 0.5px dashed #B2B7C2;
    border-radius: 4px;
    background-color: #eff4fd;
    margin-top: 8px;
    height: 120px;
    .upload-image-no {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 8px;
      img {
        width: 40px;
        height: 40px;
      }
      .upload-image-drop {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 10px;
        height: 68px;
        width: 140px;
        color: #232323;
        font-family: mon-500;
        text-align: center;
      }
      .upload-image-btn {
        width: 102px;
        height: 26px;
        background-color: #F57231;
        text-align: center;
        color: #FFFFFF;
        font-size: 10px;
        font-family: mon-600;
        line-height: 26px;
        border-radius: 20px;
        transition: all 0.3s;
        margin-top: 8px;
        cursor: pointer;
      }
      .upload-image-btn:hover {
        background-color: rgba(245, 114, 49, 0.9)
      }
      .upload-image-btn:active {
        background-color: rgba(245, 114, 49, 0.9);
        transform: scale(0.9);
      }
    }
    .upload-image-open {
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      margin: auto;
      cursor: pointer;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .reupload-image {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .upload-image-bottom {
    font-family: mon-400;
    font-size: 10px;
    color: #232323;
    line-height: 14px;
  }
  .upload-image-bottom-btn {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    .upload-image-bottom-confirm {
      width: 100%;
      height: 30px;
      line-height: 30px;
      background-color: #F57231;
      border-radius: 16px;
      color: #FFFFFF;
      font-size: 10px;
      font-family: mon-600;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;

      &.discovery {
        position: relative;
        background-color: #232323;
        color: white;
        .new-feature-tag {
          position: absolute;
          top: -7px;
          right: 0;
          width: 28px;
          height: 14px;
          border-radius: 2px;
          background-color: #1153d6;
          color: white;
          font-size: 9px;
          font-family: mon-600;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .upload-image-bottom-confirm:hover {
      background-color: rgba(245, 114, 49, 0.9)
    }
    .upload-image-bottom-confirm:active {
      background-color: rgba(245, 114, 49, 0.9);
      transform: scale(0.9);
    }
    .upload-image-bottom-cancel {
      width: 98px;
      height: 24px;
      background-color: #FFFFFF;
      border-radius: 12px;
      color: #232323;
      font-size: 12px;
      font-family: mon-600;
      text-align: center;
      line-height: 24px;
      cursor: pointer;
      border: 0.5px solid #B2B7C2;
      transition: all 0.3s;
    }
    .upload-image-bottom-cancel:active {
      transform: scale(0.9);
    }
  }
  .upload-auto_input {
    opacity: 0;
    position: absolute;
    width: 124px;
    height: 24px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}

.upload-image-tempUrl {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.upload-image-loading-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #00000048;
  border: 0.5px solid #B2B7C2;
}
.upload-image-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 36px;
  box-sizing: border-box;
  background-color: #1C202690;
  backdrop-filter: blur(10px);
  border-radius: 4px;
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  .container-text {
    color: #fff;
    font-size: 11px;
    font-family: mon-400;
    white-space: nowrap;
    margin-left: 6px;
  }

  .spinner {
    width: 12px;
    height: 12px;
    border: 2px solid white; 
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: rotate 1s linear infinite;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
